/**
 * Tu libro de Tricount (otro fichero de Google Sheets). Como la app solo tiene acceso a los ficheros que tú eliges
 * (drive.file), se elige una vez con el selector de Google; el servidor guarda cuál es y aquí se recuerda en el dispositivo.
 */
import { checkTricountBook, type SheetsApi } from '@pf/workbook';
import { api } from './api-client.js';
import { pickSpreadsheet } from './picker.js';
import { sheetsApi } from './sheets-api.js';

const KEY = 'pf-tricount-book';
export interface TricountBook { fileId: string; name: string }

let book: TricountBook | null = (() => { try { return JSON.parse(localStorage.getItem(KEY) ?? 'null') as TricountBook | null; } catch { return null; } })();

export function setTricountBook(b: TricountBook | null) {
  book = b;
  try { if (b) localStorage.setItem(KEY, JSON.stringify(b)); else localStorage.removeItem(KEY); } catch { /* sin almacenamiento */ }
}
export const tricountBook = () => book;
/** Demostración: como si no hubiera libro de Tricount (sin tocar el que recuerda el dispositivo). */
export const hideTricountBook = () => { book = null; };
export const tricountApi = (): SheetsApi | undefined => (book ? sheetsApi(book.fileId, () => api.accessToken()) : undefined);

/** Abre el selector, comprueba que el fichero tiene formato de Tricount y lo guarda en tu cuenta. Devuelve un error o ''. */
export async function connectTricount(): Promise<string> {
  const [cfg, token] = await Promise.all([api.config(), api.accessToken()]);
  const picked = await pickSpreadsheet(cfg, token, 'Elige tu libro de Tricount');
  if (!picked) return '';
  const problem = await checkTricountBook(sheetsApi(picked.id, () => api.accessToken()));
  if (problem) return problem;
  const saved = await api.setWorkbook('tricount', picked.id);
  setTricountBook({ fileId: saved.fileId, name: saved.name });
  return '';
}
